import { message, Modal } from 'antd';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import http from 'src/services/http';
import { API_VERSION, SUCCESS_STATUSES } from 'src/utils/constants';
import { isValidEmail, isValidObject } from 'src/utils/helpers';
import './styles.scss';

type Props = {
  visible: boolean;
  close: () => void;
};

const ContactUs: FC<Props> = ({ visible, close }) => {
  const { t } = useTranslation();
  const [data, setData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    content: '',
  });
  const handleChange = (name: string, value: string): void => {
    setData({ ...data, [name]: value });
  };

  const sendEmail = async (payload: any): Promise<void> => {
    const res = await http.post(
      { path: `${API_VERSION}/users/email`, baseURL: process.env.REACT_APP_REMOTE as string },
      payload
    );
    if (SUCCESS_STATUSES.includes(res.status) || res.message === 'Email sent successfully!') {
      close();
      message.success('success');
    } else {
      message.error(res.message);
    }
  };

  const handleSubmit = (): any => {
    if (isValidObject(data) === true) {
      if (isValidEmail(data.email as string)) {
        sendEmail(data);
      } else {
        return message.error(t('invalidEmail'));
      }
    }
  };
  return (
    <div>
      <Modal open={visible} onCancel={close} centered={true} className="contact-us" footer={null}>
        <div className="contact-us-body">
          <div className="form-input-container">
            <div className="contact-header">{t('contactUs')}</div>
            <form className="form" autoComplete="off">
              <div className="contact-input">
                <label className="label">{t('name')}*</label>
                <input
                  name="firstName"
                  value={data.firstName}
                  type="text"
                  className="form-input"
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                />
              </div>
              <div className="contact-input">
                <label className="label">{t('surname')}*</label>
                <input
                  name="lastName"
                  value={data.lastName}
                  type="text"
                  className="form-input"
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                />
              </div>
              <div className="contact-input">
                <label className="label">{t('email')}*</label>
                <input
                  name="email"
                  type="email"
                  value={data.email}
                  className="form-input"
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                />
              </div>
              <div className="contact-input">
                <label className="label">{t('message')}*</label>
                <input
                  name="content"
                  type="type"
                  value={data.content}
                  className="form-input"
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                />
              </div>
            </form>
            <div className="form-footer" onClick={handleSubmit}>
              <div className="send-buuton">{t('send')}</div>
            </div>
          </div>
          <div className="contact-footer">
            <address>
              <a href="mailto:info@tourest.online">support@tourest.online</a>
            </address>
            <address>
              {' '}
              <span>{t('address')}</span>
            </address>
            <address>
              {' '}
              <a href="tel: +374 93 245235">+374 93 245235</a>
            </address>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ContactUs;
